export const proposalTypes = {
  create: 'CREATE',
  delete: 'DELETE',
  deleteUpload: 'DELETE_UPLOAD',
  patch: 'PATCH',
  upload: 'UPLOAD',
};
